import { render, staticRenderFns } from "./PerformanceSingle.vue?vue&type=template&id=5b46f67c&scoped=true&"
import script from "./PerformanceSingle.vue?vue&type=script&lang=js&"
export * from "./PerformanceSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b46f67c",
  null
  
)

export default component.exports